import { useMutation } from "@tanstack/react-query";
import { login, validateToken } from "../handlers/admin.handler";

export const useLoginMutation = () => useMutation({
    mutationFn: (data) => login(data)
});

export const useValidateTokenMutation = () => useMutation({
    mutationFn: () => validateToken()
});
